module.exports = __webpack_public_path__ + "static/media/Caregem.f1f37104.svg";